export default "__VITE_ASSET__C0Zrhl$w__"